/**************************************************
 * Nombre:       Tarjeta_Boton
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {FiberManualRecord} from '@mui/icons-material'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Suscripcion from "../Dialogos/Dialogo_Suscripcion";

const Tarjeta_Boton = ({titulo, indicador, icono, textoBoton}) => {
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Suscripcion, titulo: ''})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 4,
                background: 'rgba(255, 255, 255, 0.20)',
                backdropFilter: 'blur(5px)',
                py: 2,
                px: 2,
                color: '#fff'
            }}
        >

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 16, fontWeight: 400, letterSpacing: 6}}>{titulo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{
                    fontSize: 9,
                    fontWeight: 400,
                    backgroundColor: '#000',
                    color: '#fff',
                    pl: 1,
                    pr: 1,
                    pb: 0.4,
                    borderRadius: 6,
                    letterSpacing: 2
                }}>{indicador}
                    <FiberManualRecord sx={{fill: '#4AFF83', width: 14, height: 14, mt: 0.4, mb: -0.4, pl: 0.5}}/>
                </Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 2}}>
                <Button
                    onClick={() => abrir()}
                    startIcon={<img src={icono} width={24} height={'auto'}/>}
                    sx={{
                        py: 1,
                        px: 3,
                        borderRadius: 8,
                        background: 'rgba(255, 255, 255, 0.20)',
                        color: '#fff',
                        fontWeight: 400,
                        fontSize: 14
                    }}
                >
                    {textoBoton}
                </Button>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Boton